module.exports = __webpack_public_path__ + "static/img/Liam-Henry.bba12a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Liam-Henry.jpg
// module id = zhly
// module chunks = 0